import React from 'react'
import Icon from '../Icon'
import Tooltip from '../Tooltip'

export function InfoTip(props: {
  children: React.ReactNode
  id: string
  place?: string
  icon?: string
  /** Control the vertical alignment of the icon */
  top?: number
  iconColor?: string
  delayShow?: number
}) {
  const { children, id, place, icon, top, iconColor } = props
  const [tipId] = React.useState(Math.random() + id)
  return (
    <>
      <Icon
        color={iconColor || 'var(--color-txt-muted)'}
        top={top || 0}
        data-tip
        data-for={tipId}
        name={icon || 'info'}
        size={20}
      />
      <Tooltip
        id={tipId}
        className="tooltip__info"
        place={place || 'top'}
        effect="solid"
        delayHide={200}
        delayShow={props.delayShow || 0}>
        {children}
      </Tooltip>
    </>
  )
}

export default React.memo(InfoTip)
